import {useRef, useState} from "react";
import {Link, useParams} from 'react-router-dom';

import Grid from '@material-ui/core/Grid'

import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CircularProgress from '@material-ui/core/CircularProgress';

import ButtonPrimary from "@base/Button"
import ButtonHelp from "@base/Button/ButtonHelp"
import Title from '@base/Title'
import Subtitle from '@base/Subtitle'
import Toast from '@base/Toast'
import BuscaObjetoPostal from '@base/Inputs/BuscaObjetoPostal'

import ObjetoPostalService from "@services/ObjetoPostalService"

import {parseDate} from "@helpers/DateHelper"
import {ProcessoResolver} from "@helpers/ProcessoHelper"

import FormularioTriagem from '@pages/Triagem/FormularioTriagem/FormularioTriagem'
import {ObjetoPostalNaoExistenteDialog} from "./ObjetoPostalNaoExistenteDialog";
import EncaminharObjetoPostalDialog from '@base/Dialog/ObjetoPostal/EncaminharObjetoPostalDialog'

const useStyles = makeStyles(
  (theme) => (
    {
      wrapper: {
        padding: theme.spacing(2)
      },
      title: {
        color: "#333",
        fontSize: 24,
      }
    }
  )
);

export const Triagem = (props) => {


  const [loading, setLoading] = useState(false);
  const [ultimoObjetoPostalSelecionado, setUltimoObjetoPostalSelecionado] = useState({});
  const [objetoPostalSelecionado, setObjetoPostalSelecionado] = useState({});
  const [diaPostagem, setDiaPostagem] = useState("");
  const [mesPostagem, setMesPostagem] = useState("");
  const [dataPostagem, setDataPostagem] = useState("");
  const [semDataPostagem, setSemDataPostagem] = useState(false);

  const [caixa, setCaixa] = useState();

  const params = useParams();
  const processo = ProcessoResolver(params.processo);
  const meuEstilo = useStyles();
  const toastRef = useRef(null);
  const buscaObjetoPostalTextField = useRef(null);
  const dialogCriarObjetoPostalRef = useRef(null);
  const [conteudoNaoPrevisto, setConteudoNaoPrevisto] = useState(false);
  const [conteudoNaoRelacionadoObmep, setConteudoNaoRelacionadoObmep] = useState(false);
  const [materialDanificado, setMaterialDanificado] = useState(false);
  const [openDialogCriarObjetoPostal, setOpenDialogCriarObjetoPostal] = useState(false);
  const [openEncaminharObjetoPostalDialog, setOpenEncaminharObjetoPostalDialog] = useState(false);

  const [numeroObjetoPostal, setNumeroObjetoPostal] = useState("");
  const [statusMensagem, setStatusMensagem] = useState('');
  const [mensagem, setMensagem] = useState('');

  const isValido = (obj) => {
    let mensagem = "";

    if (obj.dataPostagem != null && obj.dataPostagem.length !== 10) {
      mensagem += `<li>O campo 'Data de postagem' é obrigatório.</li>`;
    }

    return {
      ok: mensagem === "",
      mensagem: `${mensagem}`
    }

  }

  const registrarTriagem = () => {

    setLoading(true);


    if (!semDataPostagem && !(diaPostagem && mesPostagem)) {
      toastRef.current.show("error", "Data da Postagem é obrigatória.");
      setLoading(false);
    } else {


      let form = {
        "processo": processo.id,
        "dataPostagem": !semDataPostagem && diaPostagem && mesPostagem
              ? diaPostagem.toString().padStart(2, '0') + "/" + mesPostagem.toString().padStart(2, '0') + "/" + new Date().getFullYear() : null,
        "materialDanificado": materialDanificado,
        "conteudoNaoPrevisto" : conteudoNaoPrevisto,
        "conteudoNaoRelacionadoObmep" : conteudoNaoRelacionadoObmep,
        "numeroObjetoPostal": objetoPostalSelecionado.numeroObjetoPostal,
        "caixaId": caixa,
      }

      let resultadoValidacao = isValido(form);

      if (!resultadoValidacao.ok) {

        toastRef.current.show("error", resultadoValidacao.mensagem);
        setLoading(false);

      } else {

        let promises = [ObjetoPostalService.registrarTriagem(processo.id, form)];

        Promise.all(promises).then((valores) => {

          if (parseDate(form.dataPostagem) > parseDate(processo.dataLimitePostagem)) {

            toastRef.current.show("warning", "Triagem lançada com sucesso, porém após a data limite de postagem");

          } else {

            toastRef.current.show("success", "Triagem lançada com sucesso.");

          }

          limparState();
          finalRedirect();

        }).catch(error => toastRef.current.show("error", "Ocorreu um problema ao salvar o lançamento da triagem " + error.response.data.mensagens.map(mensagen => mensagen).join(" ,")))
          .finally(() => setLoading(false));
      }
    }
  }

  const finalRedirect = () => {
    setLoading(false)
  }

  const limparState = () => {
    setNumeroObjetoPostal("");
    setDiaPostagem("");
    setMesPostagem("");
    setDataPostagem("");
    setSemDataPostagem(false);
    setUltimoObjetoPostalSelecionado(objetoPostalSelecionado);
    setObjetoPostalSelecionado({});
    setCaixa("");
    setMaterialDanificado(false);
    setConteudoNaoPrevisto(false);
    setConteudoNaoRelacionadoObmep(false);
    buscaObjetoPostalTextField.current.focus();
    setMensagem("");
    setStatusMensagem("");
  }

  const objetoPostalNaoEncontrado = (objetoPostal) => {
    console.log(objetoPostal)

    setNumeroObjetoPostal(objetoPostal);
    setOpenDialogCriarObjetoPostal(true)
  }

  const objetoPostalEncontrado = (objetoPostal) => {

    if (objetoPostal.status !== "RECEBIDO") {
      setMensagem("Este objeto postal já teve a triagem realizada!");

      switch (objetoPostal.status) {
        case "RECEBIDO":
          setStatusMensagem('Triagem');
          break;
        case "TRIADO":
          setStatusMensagem('Lançamento');
          break;
        case "LANCADO":
          setStatusMensagem('Digitalização');
          break;
        case "EM_RECONTAGEM":
          setStatusMensagem('Recontagem');
          break;
        case "FINALIZADO":
          setStatusMensagem('Armazenamento');
          break;
        default:
          break;
      }

      setOpenEncaminharObjetoPostalDialog(true);

    } else {

      setObjetoPostalSelecionado(objetoPostal);
      setCaixa(objetoPostal.caixaCodigo);
      setConteudoNaoPrevisto(objetoPostal.conteudoNaoPrevisto);
      setConteudoNaoRelacionadoObmep(objetoPostal.conteudoNaoRelacionadoObmep);

      if (objetoPostal.objetoPostalCorreios) {
        const data = parseDate(objetoPostal.objetoPostalCorreios.dataPostagem);
        setDataPostagem(objetoPostal.objetoPostalCorreios?.dataPostagem);
        setDiaPostagem(data.getDate());
        setMesPostagem((data.getMonth() + 1) < 10 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1);
      }
    }
  }

  const fecharDialog = (ObjetoPostal) => {
    if (openDialogCriarObjetoPostal) {
      setOpenDialogCriarObjetoPostal(false);

    }
  }


  return (
    <>
      <Toast ref={toastRef}/>

      <Title>Triagem <ButtonHelp tipo="TRIAGEM" /> </Title>
      <br/>
      <Grid item container spacing={3}>
        <Grid item sm={8} lg={8}>
          {((objetoPostalSelecionado === undefined) || (objetoPostalSelecionado.numeroObjetoPostal === undefined)) &&
            <BuscaObjetoPostal
              inputRef={buscaObjetoPostalTextField}
              size={4}
              autoFocus
              processo={processo}
              aoencontrar={objetoPostalEncontrado}
              aonaoencontrar={objetoPostalNaoEncontrado}
              numeroObjetoPostal={numeroObjetoPostal}
            />}

        </Grid>
        {ultimoObjetoPostalSelecionado.id ?
          <Grid item sm={4} lg={4}>
            <div style={{backgroundColor: "#fff", padding: 20}}>
              <Subtitle style={{margin: 0, fontSize: 15}}>Último Objeto Postal Lançado:</Subtitle>
              {ultimoObjetoPostalSelecionado.numeroObjetoPostal}<br/>
              <Link style={{cursor: "pointer", fontWeight: "bold"}}
                    to={`/${processo.id}/objetosPostais/${ultimoObjetoPostalSelecionado.numeroObjetoPostal}`}>Consultar</Link>
            </div>
          </Grid> : <></>}
      </Grid>

      {objetoPostalSelecionado.numeroObjetoPostal !== undefined &&
        <>
          <FormularioTriagem
            numeroObjetoPostal={objetoPostalSelecionado.numeroObjetoPostal}
            possuiCaixaAssociado={objetoPostalSelecionado.caixa !== undefined}
            caixa={caixa}
            handleCaixa={setCaixa}

            materialDanificado={materialDanificado}
            handleMaterialDanificado={setMaterialDanificado}

            conteudoNaoPrevisto={conteudoNaoPrevisto}
						handleConteudoNaoPrevisto={setConteudoNaoPrevisto}

            conteudoNaoRelacionadoObmep={conteudoNaoRelacionadoObmep}
						handleConteudoNaoRelacionadoObmep={setConteudoNaoRelacionadoObmep}

            semDataPostagem={semDataPostagem}
            handleSemDataPostagem={setSemDataPostagem}

            diaPostagem={diaPostagem}
            handleDiaPostagem={setDiaPostagem}

            mesPostagem={mesPostagem}
            handleMesPostagem={setMesPostagem}

            readonly={dataPostagem ? true : false}
          />

          <br/>
          <Paper className={meuEstilo.wrapper}>
            <ButtonPrimary
              onClick={registrarTriagem}
              name="Salvar"
              startIcon={loading ? <CircularProgress size={16}/> : <AddIcon/>}
              disabled={loading}
            />
          </Paper>

        </>
      }

      {openDialogCriarObjetoPostal &&
        <ObjetoPostalNaoExistenteDialog
          aoFechar={fecharDialog}
          aberto={openDialogCriarObjetoPostal}
          ref={dialogCriarObjetoPostalRef}
          objetoPostal={numeroObjetoPostal}
          processo={processo}
          aoencontrar={objetoPostalEncontrado}

        />
      }

      {openEncaminharObjetoPostalDialog &&
        <>
          <EncaminharObjetoPostalDialog
            mensagem ={mensagem}
            statusMensagem={statusMensagem}
            close={() => {
              limparState();
              setOpenEncaminharObjetoPostalDialog(false);
            }}
            open={openEncaminharObjetoPostalDialog}
          />
        </>
      }
    </>
  );
}

export default Triagem;
